import { useMutation } from '@tanstack/react-query'
import { PUTAppealPayment } from '../requests'
import { AppealPaymentPayload } from '@/apis/providers/types/provider.types'


function useAppealPayment() {
  const mutation = useMutation({
    mutationFn: async (payload: AppealPaymentPayload & {
      applicant_appeal_message: string
    }) =>
      await PUTAppealPayment(payload),
  })

  return mutation
}

export default useAppealPayment
